import React, { useEffect, useState } from 'react'
import {useNavigate} from 'react-router-dom'
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt/js/responsive.dataTables.js';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';
import { API_URL } from '..';


const MaintenanceTable = ({jobsData}) => {
  const history = useNavigate();
  console.log(jobsData)
  const [currentUser, setCurrentUser]= useState({})
      const handleDelete = async(id)=>{
            const user = JSON.parse(localStorage.getItem('user'));
            let headersList = {
                "Accept": "*/*",
                "Content-Type": "application/json"
               }
        
               let response = await fetch(`${API_URL}/api/maintenance/delete/${id}/${user.id}`, { 
                 method: "DELETE",
                 headers: headersList
               });
               if(response.status === 200){
                window.location.href='/maintenance-logs';
               }else{
                 alert('Server Problem')
               }
      }
      function formatDate(dateString) {
        // Parse the date string into a Date object
        const date = new Date(dateString);
    
        // Define an array of month names
        const months = [
            "January", "February", "March", "April", "May", "June", 
            "July", "August", "September", "October", "November", "December"
        ];
    
        // Extract day, month, and year from the Date object
        const day = date.getUTCDate(); // Use getUTCDate for consistent UTC handling
        const month = months[date.getUTCMonth()]; // getUTCMonth returns zero-based index
        const year = date.getUTCFullYear();
    
        // Format the string
        return `${day} ${month.slice(0,3)} ${year}`;
    }
    useEffect(() => {
      const user = JSON.parse(localStorage.getItem('user'))
        setCurrentUser(user)
        const table = $('#dataTable').DataTable({
        data: jobsData,
        responsive:true,
        pageLength: 10,
         columns: [
            { data: 'id' },
            { data: 'truck.name' },
       
            { data: 'service_date',render:function(data,type,row){
                return`<span>${data ? formatDate(data): 'N/a'}</span>`;
            } },
            { data: 'resolved_status',render:function(data,type,row){
                
              return`
              <select class="form-control" onchange="window.changeStatusFunction('${row.id}',this.value)">
              <option value="Yes" ${data === true ? "selected" : ""}>Yes</option>
              <option value="No" ${data === false ? "selected" : ""}>No</option>
            </select>
             `;
            } },
            {
              data: null, // Indicates this column is generated using the `render` function
              render: function (data, type, row) {
                // Return HTML string for buttons
                return `
                <div class="dropdown">
                <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="ph ph-list"></i>
                </button>
                <ul class="dropdown-menu">
                
                  
                  <li><a style="cursor:pointer" class="dropdown-item view-btn" data-id="${row.id}"><i class="ph ph-eye"></i> View </a></li>
                  <li><a style="cursor:pointer" class="dropdown-item edit-btn" data-id="${row.id}"><i class="ph ph-pencil"></i> Edit </a></li>
                  <li><a style="cursor:pointer" class="dropdown-item delete-btn" data-id="${row.id}"><i class="ph ph-trash"></i> Delete </a></li>
                </ul>
              </div>
               
                `;
              },
              title: 'Actions', // The header for the column
              orderable: false // Optional: Prevent sorting on this column
            }
        ]
            
        });
        $('#dataTable tbody').on('click', '.edit-btn', function () {
          const id = $(this).data('id');
          history(`/edit-schedule-maintenance/${id}`); // Navigate to the edit page
        });
        $('#dataTable tbody').on('click', '.view-btn', function () {
          const id = $(this).data('id');
          history(`/view-schedule-maintenance/${id}`); // Navigate to the edit page
        });
    
        // Event listener for delete button
        $('#dataTable tbody').on('click', '.delete-btn', function () {
          const id = $(this).data('id');
          handleDelete(id); // Call the delete function
        });
        return () => {
            table.destroy(true);
        };
    }, [jobsData]);
    const changeStatusFunction = async (id,  status) => {
      const obj = jobsData.filter((item)=>item.id== id);
    
      const user = JSON.parse(localStorage.getItem('user'))
      try {
        const headersList = {
          Accept: "*/*",
          "Content-Type": "application/json",
        };
       
        let bodyContent = JSON.stringify({
          "truck_id":obj.truck_id,
           "issue_description": obj.issue_description,
           "service_date": obj.service_date,
           "cost": obj.cost,
           "resolved_status": status == 'Yes' ? 1  : 0,
           "poc_number":obj.poc_number
    
         });
         let response = await fetch(`${API_URL}/api/maintenance/update/${id}/${user.id}`, {
           method: "PUT",
           body: bodyContent,
           headers: headersList
         });
  
       
  
        if (response.status === 200) {
          window.location.reload();
          
          // Optionally update jobsData state here if needed
        } else {
          console.error("Failed to update status:", response.statusText);
        }
      } catch (error) {
        console.error("Error updating status:", error);
      }
    };
  
    // Attach changeStatusFunction to window immediately
    useEffect(() => {
      window.changeStatusFunction = changeStatusFunction;
      return () => {
        delete window.changeStatusFunction; // Cleanup on unmount
      };
    }, []);
    return (
        <div className="card basic-data-table">
        <div className="card-header">
          <div className="row">
            <h5 className="col-md-6 card-title mb-0">Maintenance Logs</h5>
            <div class="col-md-6 text-end">
            <Link className="btn btn-info" to={'/schedule-maintenance'}>
              Schedule New
            </Link>
            </div>
          </div>
        </div>
        <div className="card-body">
          <table className="table bordered-table mb-0" id="dataTable">
            <thead>
              <tr>
                <th scope="col">
                  <div className="form-check style-check d-flex align-items-center">
                    
                    <label className="form-check-label">ID</label>
                  </div>
                </th>
                <th scope="col">Vehicle Info</th>
                
             
                <th scope="col">Service Date</th>
                
                <th scope="col">Resolved</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {/* DataTables will populate this tbody */}
            </tbody>
          </table>
        </div>
      </div>
    )
}

export default MaintenanceTable